export default "__VITE_ASSET__xGCLq_Jf__"